import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  createTax,
  createTemplate,
  getListCountry,
  updateTax,
  updateTemplate,
} from "../../services/MoloniServices";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddIdentificationTemplates = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [templateData, setTemplateData] = useState({
    id: "",
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [currentStep, setCurrentStep] = useState("step1");
  const [timeZoneList, setTimeZoneList] = useState([]);

  useEffect(() => {
    if (state) {
      setTemplateData({
        id: state?.id,
        name: state?.name,
        business_name: state?.business_name,
        email: state?.email,
        address: state?.address,
        city: state?.city,
        zip_code: state?.zip_code,
        phone: state?.phone,
        fax: state?.fax,
        website: state?.website,
        documents_footnote: state?.documents_footnote,
        email_sender_name: state?.email_sender_name,
        email_sender_address: state?.email_sender_address,
        country_id: state?.country_id,
        moloni_id: state?.moloni_id,
        notes: state?.notes,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!templateData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!templateData.business_name) {
      errorObj.business_name = `Business name is required.`;
      error = true;
    }

    if (!templateData.email) {
      errorObj.email = `Email is required.`;
      error = true;
    }

    if (!templateData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!templateData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!templateData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!templateData.email_sender_name) {
      errorObj.email_sender_name = `Email Sender Name is required.`;
      error = true;
    }

    if (!templateData.email_sender_address) {
      errorObj.email_sender_address = `Email Sender Address is required.`;
      error = true;
    }

    if (!templateData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (templateData.website) {
      const isValidUrl = /^https?:\/\//.test(templateData.website);
      if (!isValidUrl) {
        errorObj.website = "Website must start with http:// or https://";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      name: templateData?.name,
      business_name: templateData?.business_name,
      email: templateData?.email,
      address: templateData?.address,
      city: templateData?.city,
      zip_code: templateData?.zip_code,
      phone: templateData?.phone,
      fax: templateData?.fax,
      website: templateData?.website,
      notes: templateData?.notes,
      documents_footnote: templateData?.documents_footnote,
      email_sender_name: templateData?.email_sender_name,
      email_sender_address: templateData?.email_sender_address,
      country_id: templateData?.country_id,
    };

    let updateData = {
      company_id: "269134",
      id: templateData?.id,
      name: templateData?.name,
      business_name: templateData?.business_name,
      email: templateData?.email,
      address: templateData?.address,
      city: templateData?.city,
      zip_code: templateData?.zip_code,
      phone: templateData?.phone,
      fax: templateData?.fax,
      website: templateData?.website,
      notes: templateData?.notes,
      documents_footnote: templateData?.documents_footnote,
      email_sender_name: templateData?.email_sender_name,
      email_sender_address: templateData?.email_sender_address,
      country_id: templateData?.country_id,
      template_id: templateData?.moloni_id,
    };

    if (templateData?.id) {
      updateTemplate(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/identificationTemplates");
          setIsModifyButtonLoad(false);
          setTemplateData({
            id: "",
            name: "",
            business_name: "",
            email: "",
            address: "",
            city: "",
            zip_code: "",
            phone: "",
            fax: "",
            website: "",
            notes: "",
            documents_footnote: "",
            email_sender_name: "",
            email_sender_address: "",
            country_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createTemplate(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/identificationTemplates");

          setIsModifyButtonLoad(false);
          setTemplateData({
            id: "",
            name: "",
            business_name: "",
            email: "",
            address: "",
            city: "",
            zip_code: "",
            phone: "",
            fax: "",
            website: "",
            notes: "",
            documents_footnote: "",
            email_sender_name: "",
            email_sender_address: "",
            country_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{"Identification Templates"}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmitForm}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <Tabs
                          activeKey={currentStep}
                          onSelect={(k) => setCurrentStep(k)}
                          className="mb-3"
                          style={{
                            marginTop: "-11px",
                            marginLeft: "-3px",
                            width: "137px",
                            borderRadius: "0px",
                          }}
                        >
                          <Tab eventKey="step1" title="Main">
                            <div className="row">
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("name")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.name}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            name: e.target.value,
                                          });
                                        }}
                                        name={`name`}
                                        maxLength={50}
                                        placeholder="Name"
                                      />
                                    </div>
                                    {errors.name && (
                                      <span className="input-error">
                                        {errors.name}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("business_name")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.business_name}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            business_name: e.target.value,
                                          });
                                        }}
                                        name={`business_name`}
                                        maxLength={50}
                                        placeholder="Business name"
                                      />
                                    </div>
                                    {errors.business_name && (
                                      <span className="input-error">
                                        {errors.business_name}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("email")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.email}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            email: e.target.value,
                                          });
                                        }}
                                        name={`email`}
                                        maxLength={50}
                                        placeholder="Email"
                                      />
                                    </div>
                                    {errors.email && (
                                      <span className="input-error">
                                        {errors.email}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("address")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.address}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            address: e.target.value,
                                          });
                                        }}
                                        name={`address`}
                                        maxLength={50}
                                        placeholder="Address"
                                      />
                                    </div>
                                    {errors.address && (
                                      <span className="input-error">
                                        {errors.address}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("city")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.city}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            city: e.target.value,
                                          });
                                        }}
                                        name={`city`}
                                        maxLength={50}
                                        placeholder="City"
                                      />
                                    </div>
                                    {errors.city && (
                                      <span className="input-error">
                                        {errors.city}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("zip_code")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.zip_code}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            zip_code: e.target.value,
                                          });
                                        }}
                                        name={`zip_code`}
                                        maxLength={50}
                                        placeholder="Zip code"
                                      />
                                    </div>
                                    {errors.zip_code && (
                                      <span className="input-error">
                                        {errors.zip_code}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("phone")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={templateData.phone}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            phone: e.target.value,
                                          });
                                        }}
                                        name={`phone`}
                                        placeholder="Phone"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("fax")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={templateData.fax}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            fax: e.target.value,
                                          });
                                        }}
                                        name={`fax`}
                                        placeholder="Fax"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("website")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.website}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            website: e.target.value,
                                          });
                                        }}
                                        name={`website`}
                                        placeholder="Website"
                                      />
                                      {errors.website && (
                                        <span className="input-error">
                                          {errors.website}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("notes")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.notes}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            notes: e.target.value,
                                          });
                                        }}
                                        name={`notes`}
                                        placeholder="Notes"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("documents_footnote")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.documents_footnote}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            documents_footnote: e.target.value,
                                          });
                                        }}
                                        name={`documents_footnote`}
                                        placeholder="Documents footnote"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("email_sender_name")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={templateData.email_sender_name}
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            email_sender_name: e.target.value,
                                          });
                                        }}
                                        name={`email_sender_name`}
                                        maxLength={50}
                                        placeholder="Email sender name"
                                      />
                                    </div>
                                    {errors.email_sender_name && (
                                      <span className="input-error">
                                        {errors.email_sender_name}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("email_sender_address")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={
                                          templateData.email_sender_address
                                        }
                                        onChange={(e) => {
                                          setTemplateData({
                                            ...templateData,
                                            email_sender_address:
                                              e.target.value,
                                          });
                                        }}
                                        name={`email_sender_address`}
                                        maxLength={50}
                                        placeholder="Email sender address"
                                      />
                                    </div>
                                    {errors.email_sender_address && (
                                      <span className="input-error">
                                        {errors.email_sender_address}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("country")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={timeZoneList}
                                        value={timeZoneList.find(
                                          (item) =>
                                            item.value ==
                                            templateData.country_id
                                        )}
                                        onChange={(selectedOption) => {
                                          setTemplateData({
                                            ...templateData,
                                            country_id: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Type"}
                                      />
                                      {errors.country_id && (
                                        <span className="input-error">
                                          {errors.country_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col ms-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate("/identificationTemplates")}
                      >
                        <i className="bi bi-arrow-left"> </i> {t("back")}
                      </button>
                    </div>
                    <div className="col">
                      <div className="d-flex justify-content-end nxt-btn">
                        {isModifyButtonLoad === true ? (
                          <button type="submit" className="btn btn-primary">
                            Loading...
                          </button>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            {t("submit")} <i className="bi bi-check2"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddIdentificationTemplates;
